import styled from 'styled-components';

export const QuoteContainer = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.colors.primary.light};
  width: 50%;
  max-height: 480px;
  display: flex;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    height: 360px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    justify-content: flex-start;
    width: 100%;
    height: 320px;
  }
`;

export default QuoteContainer;
